// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.104.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Images/bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Do the ones that uses this "placeholder" default to normal font-weight? */
#lcProductName {
    font-weight: 300;
}

.lcsg {
    background: #ffffff;
}

.lcsg-h1,
.lcsg-h2,
.lcsg-h3 {
    color: #4f7a8a;
}

.lcsg-h2 {
    margin-top: 37px;
}

.lcsg-h3 {
    margin-top: 27px;
}

.lcsg-description {
    font-size: 12px;
    line-height: 17px;
}

.lcsg-summary {
    font-size: 12px;
    line-height: 17px;
    font-weight: 700;
}

.lcsg-section {
    padding-top: 100px;
    padding-bottom: 100px;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
}

.lcsg-section .lcsg-h1:not(:first-child) {
    margin-top: 37px;
}

.lcsg-section-lifecarefont-fontweights {
    margin-top: 37px;
    text-align: center;
    font-size: 20px;
    line-height: 30px;
}

.lcsg-section-lifecarefont-fontsizes {
    margin-top: 37px;
    text-align: center;
}

.lcsg-section-lifecarefont-fontsizes h1,
.lcsg-section-lifecarefont-fontsizes h2,
.lcsg-section-lifecarefont-fontsizes h3,
.lcsg-section-lifecarefont-fontsizes h4,
.lcsg-section-lifecarefont-fontsizes label,
.lcsg-section-lifecarefont-fontsizes .bodytext,
.lcsg-section-lifecarefont-fontsizes .btn {
    margin-top: 37px;
    margin-bottom: 5px;
    line-height: 1;
}

.lcsg-section-lifecarefont-fontsizes .btn {
    display: block;
    padding: 0;
}

.lcsg-section-buttons .row + .row {
    margin-top: 16px;
}

.lcsg-section-buttons-spec .col-sm-6 + .col-sm-6 {
    font-size: 12px;
    line-height: 120%;
    padding-top: 5px;
}

.lcsg-section-textboxes .input-validation-error-message {
    position: inherit;
}

.lcsg-section-tables .lc-table-expandable__expanded-area {
    -webkit-column-count: 2;
    -moz-column-count: 2;
    -ms-column-count: 2;
    -o-column-count: 2;
    column-count: 2;
}

.lcsg-section-listbox .lc-listbox {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
}

.lcsg-section-notifications .lc-notification {
    position: inherit;
    left: 0;
    right: 0;
    margin-left: 24px;
    margin-right: 24px;
}

@media (max-width: 768px) {
    .lcsg-section-notifications .lc-notification {
        margin-left: -1px;
        margin-right: -1px;
        top: 67px;
    }
}

.lcsg-section-notifications .lc-topbanner {
    padding: 24px;
}

#toast-container {
    position: inherit;
}

@media (min-width: 768px) {
    .lcsg-section-wizard .lc-wizard {
        white-space: nowrap;
    }
}

.lcsg-section-colour > .row + .row {
    margin-top: 37px;
}

.lcsg-section-colour > .row > .col-sm-6:last-child {
    line-height: 100%;
    font-size: 12px;
}

.lcsg-section-colour > .row > .col-sm-6:last-child > div {
    display: inline-block;
    height: 30px;
    width: 80px;
    vertical-align: middle;
    margin-right: 10px;
}

.lcsg-section-colour-flex {
    display: flex;
    justify-content: space-between;
}

.lcsg-section-colour-flex + .lcsg-section-colour-flex {
    margin-top: 3px;
}

.lcsg-section-colour-flex > span {
    display: inline-block;
    width: 30px;
    height: 30px;
    border-radius: 4px;
}

.lcsg-section-colour-flex-large > span {
    display: inline-block;
    width: 48px;
    height: 48px;
    border-radius: 6px;
}

.lcsg-section-icons > div {
    display: flex;
    justify-content: space-between;
    font-size: 32px;
}

.lcsg-section-splash .lc-splash,
.lcsg-section-loading .lc-loading-layer {
    position: relative;
    height: 400px;
    border: 1px solid #b6b6b9;
}

.lcsg-section-loading .lc-loading-layer {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x;
    background-size: cover;
    overflow: hidden;
}

.lcsg-section-container .lc-container,
.lcsg-section-notifications .lc-container {
    position: relative;
    height: 400px;
}

.lcsg-section-incontainerinteraction .lc-container {
    position: relative;
    height: 473px;
}

.lcsg-section-container .lc-container__content,
.lcsg-section-notifications .lc-container__content {
    background-color: #d5d5d7;
}

.lcsg-section-notifications .lc-container__content {
    height: 243px;
}

.lcsg-section-notifications .lc-container__content-wrapper {
    padding-top: 95px;
}

@media (max-width: 768px) {
    .lcsg-section-notifications .lc-container__content {
        height: 291px;
    }

    .lcsg-section-notifications .lc-container__content-wrapper {
        padding-top: 67px;
    }
}

.lcsg-section-menu .lc-menu {
    position: relative;
    top: 0;
    height: 400px;
}

.lcsg-section-bottomnavigation .lc-bottom-navigation {
    position: relative;
}

.lcsg-section-logo .lc-topbanner {
    height: 90px;
    width: 100%;
}

.lcsg-section-back .lc-topbanner {
    height: 90px;
}

@media (max-width: 768px) {
    .lcsg-section-logo .lc-topbanner,
    .lcsg-section-back .lc-topbanner {
        height: 80px;
    }
}

.lcsg-section-incontainerinteraction .lc-master-detail {
    position: relative;
    height: 430px;
    overflow: hidden;
    overflow-y: auto;
}

@media (min-width: 768px) {
    .lcsg-section-incontainerinteraction .lc-master-detail {
        margin-left: -100px;
        margin-right: -100px;
    }
}

/* Tried out placeing in container toolbar in columns instead of absolute to bring actions closer. Still placed to right in lower res. To be continue in how to bring it into Flow. */
.lcsg-section-incontainerinteraction .lc-in-container__toolbar {
    position: inherit;
}

@media (max-width: 768px) {
    .lcsg-section-incontainerinteraction .lc-in-container__toolbar {
        text-align: right;
    }
}

.lcsg-section-toolbar .lc-in-container__toolbar {
    position: inherit;
}

.lcsg-section-toolbar .lc-container__toolbar {
    float: none;
    margin-left: -5px;
}

.lcsg-section-topbanner .lc-topbanner,
.lcsg-section-usercontext .lc-topbanner,
.lcsg-section-workingcontext .lc-topbanner {
    position: relative;
}

.lcsg-section-workingcontext .popover {
    top: 62px;
    left: 166px;
    display: block;
    width: 190px;
}

@media (min-width: 768px) {
    .lcsg-section-topbanner .lc-topbanner,
    .lcsg-section-usercontext .lc-topbanner,
    .lcsg-section-workingcontext .lc-topbanner {
        margin-left: -100px;
        margin-right: -100px;
    }

    .lcsg-section-usercontext .popover {
        top: 62px;
        left: 593px;
        display: block;
    }

    .lcsg-section-workingcontext .popover {
        left: 267px;
    }
}

.lcsg-section-workingcontext .lcsg-h2:last-of-type {
    margin-top: 150px;
}

.lcsg-section-dialog .modal {
    display: block;
    position: relative;
    background-color: #f5f5f5;
}

.lcsg-section-login .modal {
    display: block;
    position: relative;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x;
    background-size: cover;
    border: 1px solid #b6b6b9;
}

.lcsg-section-workflow > .hidden-xs {
    margin-left: -100px;
    margin-right: -100px;
    position: relative;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) repeat-x;
    background-size: cover;
    overflow: hidden;
}

.lcsg-section-workflow > .hidden-xs > .lc-menu {
    top: 151px;
}

.lcsg-section-workflow > .hidden-xs > .lc-wizard {
    margin-left: 84px;
    margin-top: 24px;
    margin-bottom: 12px;
}

.lcsg-section-workflow > .hidden-xs > .row {
    margin-left: 68px;
}

#lcsg-nav .nav > li > a {
    position: inherit;
    display: inherit;
    padding: inherit;
}

#lcsg-nav .nav > li > a:hover,
#lcsg-nav .nav > li > a:focus {
    text-decoration: inherit;
    background-color: inherit;
}

#lcsg-nav .nav > li.active > a {
    font-weight: 700;
}

#lcsg-nav .nav > li.active > a:hover,
#lcsg-nav .nav > li.active > a:focus {
    color: #337b99;
}
.styleguideInformation {
    background: #ffdde1;
    padding: 20px;
    color: #c34a53;
    margin-top: 80px;
    font-weight: 600;
    border: 1px solid #c34a53;
}
`, "",{"version":3,"sources":["webpack://./Scripts/styleguide/citizen.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;;;;;IAOI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,OAAO;IACP,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,SAAS;IACb;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,4DAA+C;IAC/C,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;;QAEI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA,qLAAqL;AACrL;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,cAAc;IACd,YAAY;AAChB;;AAEA;IACI;;;QAGI,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,4DAA+C;IAC/C,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,4DAA+C;IAC/C,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;IAEI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B","sourcesContent":["/* Do the ones that uses this \"placeholder\" default to normal font-weight? */\r\n#lcProductName {\r\n    font-weight: 300;\r\n}\r\n\r\n.lcsg {\r\n    background: #ffffff;\r\n}\r\n\r\n.lcsg-h1,\r\n.lcsg-h2,\r\n.lcsg-h3 {\r\n    color: #4f7a8a;\r\n}\r\n\r\n.lcsg-h2 {\r\n    margin-top: 37px;\r\n}\r\n\r\n.lcsg-h3 {\r\n    margin-top: 27px;\r\n}\r\n\r\n.lcsg-description {\r\n    font-size: 12px;\r\n    line-height: 17px;\r\n}\r\n\r\n.lcsg-summary {\r\n    font-size: 12px;\r\n    line-height: 17px;\r\n    font-weight: 700;\r\n}\r\n\r\n.lcsg-section {\r\n    padding-top: 100px;\r\n    padding-bottom: 100px;\r\n    max-width: 640px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.lcsg-section .lcsg-h1:not(:first-child) {\r\n    margin-top: 37px;\r\n}\r\n\r\n.lcsg-section-lifecarefont-fontweights {\r\n    margin-top: 37px;\r\n    text-align: center;\r\n    font-size: 20px;\r\n    line-height: 30px;\r\n}\r\n\r\n.lcsg-section-lifecarefont-fontsizes {\r\n    margin-top: 37px;\r\n    text-align: center;\r\n}\r\n\r\n.lcsg-section-lifecarefont-fontsizes h1,\r\n.lcsg-section-lifecarefont-fontsizes h2,\r\n.lcsg-section-lifecarefont-fontsizes h3,\r\n.lcsg-section-lifecarefont-fontsizes h4,\r\n.lcsg-section-lifecarefont-fontsizes label,\r\n.lcsg-section-lifecarefont-fontsizes .bodytext,\r\n.lcsg-section-lifecarefont-fontsizes .btn {\r\n    margin-top: 37px;\r\n    margin-bottom: 5px;\r\n    line-height: 1;\r\n}\r\n\r\n.lcsg-section-lifecarefont-fontsizes .btn {\r\n    display: block;\r\n    padding: 0;\r\n}\r\n\r\n.lcsg-section-buttons .row + .row {\r\n    margin-top: 16px;\r\n}\r\n\r\n.lcsg-section-buttons-spec .col-sm-6 + .col-sm-6 {\r\n    font-size: 12px;\r\n    line-height: 120%;\r\n    padding-top: 5px;\r\n}\r\n\r\n.lcsg-section-textboxes .input-validation-error-message {\r\n    position: inherit;\r\n}\r\n\r\n.lcsg-section-tables .lc-table-expandable__expanded-area {\r\n    -webkit-column-count: 2;\r\n    -moz-column-count: 2;\r\n    -ms-column-count: 2;\r\n    -o-column-count: 2;\r\n    column-count: 2;\r\n}\r\n\r\n.lcsg-section-listbox .lc-listbox {\r\n    max-width: 300px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.lcsg-section-notifications .lc-notification {\r\n    position: inherit;\r\n    left: 0;\r\n    right: 0;\r\n    margin-left: 24px;\r\n    margin-right: 24px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .lcsg-section-notifications .lc-notification {\r\n        margin-left: -1px;\r\n        margin-right: -1px;\r\n        top: 67px;\r\n    }\r\n}\r\n\r\n.lcsg-section-notifications .lc-topbanner {\r\n    padding: 24px;\r\n}\r\n\r\n#toast-container {\r\n    position: inherit;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .lcsg-section-wizard .lc-wizard {\r\n        white-space: nowrap;\r\n    }\r\n}\r\n\r\n.lcsg-section-colour > .row + .row {\r\n    margin-top: 37px;\r\n}\r\n\r\n.lcsg-section-colour > .row > .col-sm-6:last-child {\r\n    line-height: 100%;\r\n    font-size: 12px;\r\n}\r\n\r\n.lcsg-section-colour > .row > .col-sm-6:last-child > div {\r\n    display: inline-block;\r\n    height: 30px;\r\n    width: 80px;\r\n    vertical-align: middle;\r\n    margin-right: 10px;\r\n}\r\n\r\n.lcsg-section-colour-flex {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.lcsg-section-colour-flex + .lcsg-section-colour-flex {\r\n    margin-top: 3px;\r\n}\r\n\r\n.lcsg-section-colour-flex > span {\r\n    display: inline-block;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 4px;\r\n}\r\n\r\n.lcsg-section-colour-flex-large > span {\r\n    display: inline-block;\r\n    width: 48px;\r\n    height: 48px;\r\n    border-radius: 6px;\r\n}\r\n\r\n.lcsg-section-icons > div {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-size: 32px;\r\n}\r\n\r\n.lcsg-section-splash .lc-splash,\r\n.lcsg-section-loading .lc-loading-layer {\r\n    position: relative;\r\n    height: 400px;\r\n    border: 1px solid #b6b6b9;\r\n}\r\n\r\n.lcsg-section-loading .lc-loading-layer {\r\n    background: url(\"../../Images/bg.png\") repeat-x;\r\n    background-size: cover;\r\n    overflow: hidden;\r\n}\r\n\r\n.lcsg-section-container .lc-container,\r\n.lcsg-section-notifications .lc-container {\r\n    position: relative;\r\n    height: 400px;\r\n}\r\n\r\n.lcsg-section-incontainerinteraction .lc-container {\r\n    position: relative;\r\n    height: 473px;\r\n}\r\n\r\n.lcsg-section-container .lc-container__content,\r\n.lcsg-section-notifications .lc-container__content {\r\n    background-color: #d5d5d7;\r\n}\r\n\r\n.lcsg-section-notifications .lc-container__content {\r\n    height: 243px;\r\n}\r\n\r\n.lcsg-section-notifications .lc-container__content-wrapper {\r\n    padding-top: 95px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .lcsg-section-notifications .lc-container__content {\r\n        height: 291px;\r\n    }\r\n\r\n    .lcsg-section-notifications .lc-container__content-wrapper {\r\n        padding-top: 67px;\r\n    }\r\n}\r\n\r\n.lcsg-section-menu .lc-menu {\r\n    position: relative;\r\n    top: 0;\r\n    height: 400px;\r\n}\r\n\r\n.lcsg-section-bottomnavigation .lc-bottom-navigation {\r\n    position: relative;\r\n}\r\n\r\n.lcsg-section-logo .lc-topbanner {\r\n    height: 90px;\r\n    width: 100%;\r\n}\r\n\r\n.lcsg-section-back .lc-topbanner {\r\n    height: 90px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .lcsg-section-logo .lc-topbanner,\r\n    .lcsg-section-back .lc-topbanner {\r\n        height: 80px;\r\n    }\r\n}\r\n\r\n.lcsg-section-incontainerinteraction .lc-master-detail {\r\n    position: relative;\r\n    height: 430px;\r\n    overflow: hidden;\r\n    overflow-y: auto;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .lcsg-section-incontainerinteraction .lc-master-detail {\r\n        margin-left: -100px;\r\n        margin-right: -100px;\r\n    }\r\n}\r\n\r\n/* Tried out placeing in container toolbar in columns instead of absolute to bring actions closer. Still placed to right in lower res. To be continue in how to bring it into Flow. */\r\n.lcsg-section-incontainerinteraction .lc-in-container__toolbar {\r\n    position: inherit;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .lcsg-section-incontainerinteraction .lc-in-container__toolbar {\r\n        text-align: right;\r\n    }\r\n}\r\n\r\n.lcsg-section-toolbar .lc-in-container__toolbar {\r\n    position: inherit;\r\n}\r\n\r\n.lcsg-section-toolbar .lc-container__toolbar {\r\n    float: none;\r\n    margin-left: -5px;\r\n}\r\n\r\n.lcsg-section-topbanner .lc-topbanner,\r\n.lcsg-section-usercontext .lc-topbanner,\r\n.lcsg-section-workingcontext .lc-topbanner {\r\n    position: relative;\r\n}\r\n\r\n.lcsg-section-workingcontext .popover {\r\n    top: 62px;\r\n    left: 166px;\r\n    display: block;\r\n    width: 190px;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .lcsg-section-topbanner .lc-topbanner,\r\n    .lcsg-section-usercontext .lc-topbanner,\r\n    .lcsg-section-workingcontext .lc-topbanner {\r\n        margin-left: -100px;\r\n        margin-right: -100px;\r\n    }\r\n\r\n    .lcsg-section-usercontext .popover {\r\n        top: 62px;\r\n        left: 593px;\r\n        display: block;\r\n    }\r\n\r\n    .lcsg-section-workingcontext .popover {\r\n        left: 267px;\r\n    }\r\n}\r\n\r\n.lcsg-section-workingcontext .lcsg-h2:last-of-type {\r\n    margin-top: 150px;\r\n}\r\n\r\n.lcsg-section-dialog .modal {\r\n    display: block;\r\n    position: relative;\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n.lcsg-section-login .modal {\r\n    display: block;\r\n    position: relative;\r\n    background: url(\"../../Images/bg.png\") repeat-x;\r\n    background-size: cover;\r\n    border: 1px solid #b6b6b9;\r\n}\r\n\r\n.lcsg-section-workflow > .hidden-xs {\r\n    margin-left: -100px;\r\n    margin-right: -100px;\r\n    position: relative;\r\n    background: url(\"../../Images/bg.png\") repeat-x;\r\n    background-size: cover;\r\n    overflow: hidden;\r\n}\r\n\r\n.lcsg-section-workflow > .hidden-xs > .lc-menu {\r\n    top: 151px;\r\n}\r\n\r\n.lcsg-section-workflow > .hidden-xs > .lc-wizard {\r\n    margin-left: 84px;\r\n    margin-top: 24px;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.lcsg-section-workflow > .hidden-xs > .row {\r\n    margin-left: 68px;\r\n}\r\n\r\n#lcsg-nav .nav > li > a {\r\n    position: inherit;\r\n    display: inherit;\r\n    padding: inherit;\r\n}\r\n\r\n#lcsg-nav .nav > li > a:hover,\r\n#lcsg-nav .nav > li > a:focus {\r\n    text-decoration: inherit;\r\n    background-color: inherit;\r\n}\r\n\r\n#lcsg-nav .nav > li.active > a {\r\n    font-weight: 700;\r\n}\r\n\r\n#lcsg-nav .nav > li.active > a:hover,\r\n#lcsg-nav .nav > li.active > a:focus {\r\n    color: #337b99;\r\n}\r\n.styleguideInformation {\r\n    background: #ffdde1;\r\n    padding: 20px;\r\n    color: #c34a53;\r\n    margin-top: 80px;\r\n    font-weight: 600;\r\n    border: 1px solid #c34a53;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
